import { getAuthorizationToken } from "../../connections/atlassian/http.header.authorization";

export const post = (url, body = {}) => {
  return doRequest(url, "POST", body);
};
export const get = (url) => {
  return doRequest(url, "GET");
};
export const del = (url, body = {}) => {
  return doRequest(url, "DELETE", body);
};
export const put = (url, body = {}) => {
  return doRequest(url, "PUT", body);
};

const doRequest = async (url, method, body) => {
  const requestBody = body == null ? null : JSON.stringify(body);
  let fetchSettings = {
    headers: { "Content-Type": "application/json", Authorization: await getAuthorizationToken() },
    method: method,
  };

  if (requestBody != null) {
    fetchSettings = { ...fetchSettings, ...{ body: requestBody } };
  }
  const fetchResponse = await fetch(url, fetchSettings);
  if (method === "DELETE" && fetchResponse.ok) {
    return "OK";
  }
  return fetchResponse.ok ? fetchResponse.json() : Promise.reject(fetchResponse);
};
